//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/NXObject.js";
let d=[[[0,"ImageBackground",0,0],[0,"ImageSize",0,0],[0,"OpenDocument",0,0],[0,"OutputFileName",0,0],[0,"SaveImages",0,0],[0,"TemplateFileName",0,0],[0,"ViewportSettingsCount",0,0]],[[["label"],"GetTextValueOfLabel",{R_:{value:''}},1,0],[["index"],"GetViewportSettings",{R_:{viewportSettings:"DesignSimulation.ViewportSettings"}},1,0]],[]];
SPLM.DesignSimulation.AnalysisReportSettings = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.AnalysisReportSettings";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;